export const MAIL_TO = "mailto:contact@pimento.design";
